module.exports = __webpack_public_path__ + "media/vuesrc/apps/public/images/investments/money-tree-ef7d6125df20f1e42a02728b5736081c.jpg";